module.exports = __webpack_public_path__ + "static/media/HELMET.094997e6.svg";